<template>
    <span v-on:click.prevent class="eyebrow-icon" v-bind:class="[eyebrowicon.icon, eyebrowicon.color, align]"></span>
</template>

<script>
    export default {
        name: 'eyebrow-icon',
        props: ['eyebrowicon', 'align']
    }
</script>

<style lang="scss" scoped>
    span {
        display: block;
        cursor: default;

        &.center {
            margin: 0 auto;
        }
    }
</style>